// extracted by mini-css-extract-plugin
export default {"clipboardModeIcon":"E-QXJzi7Qig53K56zuK8GA==","clipboardModeContent":"tlKjZEMFKfWg7LKCDKMz-A=="};